import React from 'react'

const EDUCATION_DATA = [
    {
        period: '2019 - 2023',
        degree: 'B.tech - Computer Science',
        institution: 'Mar Athanasius College Of Engineering, Kothamangalam',
    },
    {
        period: '2016 - 2018',
        degree: 'Class XI & XII - Computer Science',
        institution: 'D.U.H.S.S Panakkad',
    },
    {
        period: '2015 - 2016',
        degree: 'Class X',
        institution: 'G.V.H.S.S Vengara',
    },
];

const Education = () => {
    return (
        <div className='p-4 overflow-y-auto '>
            <h3 className='pb-4 text-lg font-semibold'>Education Journey</h3>
            <ol className='relative border-l border-darkTheme-bg-tertiary'>
                {EDUCATION_DATA.map((item, index) => (
                    <li key={index} className='mb-10 ml-4'>
                        <div className='absolute w-3 h-3 rounded-full mt-1.5 -left-1.5 border border-darkTheme-bg-tertiary bg-darkTheme-bg-primary'></div>
                        <time className='mb-1 text-sm font-normal leading-none text-darkTheme-accent-primary'>{item.period}</time>
                        <h3 className='text-base font-semibold text-darkTheme-fg-primary'>{item.degree}</h3>
                        <p className='mb-4 text-sm font-normal text-darkTheme-fg-tertiary'>{item.institution}</p>
                    </li>
                ))}
            </ol>
        </div>
    );
}

export default Education